
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {}
})
export default class Compatibility extends Vue {
  @Prop() private title!: String;
  @Prop() private score!: Number;
  @Prop() private isOffer!: Boolean;
  @Prop() private success!: Boolean;
  @Prop() private profileImg!: String;
}
